export enum bandIcons {
    iconOk = 'assets/icon/band-icon.png',
    iconOffline = 'assets/icon/band-icon_offline.png',
    iconLowBatt = 'assets/icon/band-icon_lowbatt.png',
    iconUnworn = 'assets/icon/band-icon_unworn.png',
    iconDefault = 'assets/images/band-icon_faded.png'
}
